import type {
	FormSubmissionSpamState,
	FormSubmissionStatus,
} from '../models/entity/form-submission.entity';

/**
 * PD-16573 — how the inbox names a submission's status and spam check. One place, so the
 * list's badges, its filters and the detail page say the same thing.
 */
export const FORM_SUBMISSION_STATUS_LABELS: Readonly<
	Record<FormSubmissionStatus, string>
> = {
	new: 'New',
	in_review: 'In review',
	converted: 'Converted',
	linked: 'Linked',
	dismissed: 'Dismissed',
};

export const FORM_SUBMISSION_SPAM_LABELS: Readonly<
	Record<FormSubmissionSpamState, string>
> = {
	clean: 'Passed',
	spam: 'Spam',
	duplicate: 'Duplicate',
	unverified: 'Unverified',
};
